import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';


export const HotelCenterAssignment = globalContext.define(
  [
    '@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center',
    'campaignui/feature/griddownload/view/adapter',
    'campaignui/feature/hotel-center-edm/index',
    'campaignui/feature/hotel-center-js-data/index',
    'component/bingads-grid/plugin/cross-page-select-all/index',
    'component/bingads-grid/shared/column',
    'component/bingads-grid/shared/schema-util',
    'component/i18n/loader!campaignui/feature/hotel-center',
    'component/state/index',
    'component/config/index',
    'component/bingads-grid/service/custom-userinfo-preferences',
    'component/js-data-campaign/index',
    '@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center-shared',
    'PageContext',
    'component/bingads-grid/service/date-filter-preferences',
  ],
  Promise => import(/* webpackMode: 'eager' */ './src/hotel-center-assignment') // eslint-disable-line no-unused-vars
);

